// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heade__container {
    position: fixed;
    z-index: 10;
    width: 100%;
    --tw-bg-opacity: 1;
    background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.header__row {
    display: flex;
    height: 4rem;
    align-items: center;
    justify-content: space-between
}
.header__col--icon {
    cursor: pointer;
    transition-property: all;
    transition-delay: 150ms;
    transition-duration: 150ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1)
}
.header__col--icon:hover {
    --tw-text-opacity: 1;
    color: rgb(129 140 248 / var(--tw-text-opacity, 1))
}`, "",{"version":3,"sources":["webpack://./src/components/global/Header/header.css"],"names":[],"mappings":"AACI;IAAA,eAA+C;IAA/C,WAA+C;IAA/C,WAA+C;IAA/C,kBAA+C;IAA/C,4DAA+C;IAA/C,oBAA+C;IAA/C,qBAA+C;IAA/C,0EAA+C;IAA/C,8FAA+C;IAA/C;AAA+C;AAG/C;IAAA,aAA6C;IAA7C,YAA6C;IAA7C,mBAA6C;IAA7C;AAA6C;AAG7C;IAAA,eAA6F;IAA7F,wBAA6F;IAA7F,uBAA6F;IAA7F,0BAA6F;IAA7F;AAA6F;AAA7F;IAAA,oBAA6F;IAA7F;AAA6F","sourcesContent":[".heade__container{\n    @apply w-full bg-gray-50 fixed z-10 shadow px-6;\n}\n.header__row {\n    @apply h-16 flex items-center justify-between; \n}\n.header__col--icon {\n    @apply cursor-pointer transition-all ease-in-out duration-150 delay-150 hover:text-indigo-400; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
